import { translatedProperty } from "./translated-property.filter";
import Vue from 'vue';

Vue.filter('translated-property', translatedProperty);